module.exports = __webpack_public_path__ + "static/media/deadline.4f86291f.png";